import type { RawParams } from "@uirouter/react";

import { CRM_LIST_PAGE_ROUTE, STATIC_LIST_PAGE_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import type { CrmListObjectType } from "app/pages/sales-intelligence/domain/crm-integration/types/object-type";
import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import type { ListParams } from "app/pages/sales-intelligence/domain/lists/types/list";
import { ListVariant } from "app/pages/sales-intelligence/domain/lists/types/list";
import { makeCrmListId } from "app/pages/sales-intelligence/domain/lists/utils/list-id";
import { trackError } from "app/pages/sales-intelligence/utils/errors/tracking";
import { errorCategoryMap, SiError } from "app/pages/sales-intelligence/utils/errors/types";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

export const getOpportunityListParams = (params: RawParams, state: IRouterState): ListParams | undefined => {
    const { id, crm, objectType } = params as {
        id: string;
        crm: CrmIntegrationProvider;
        objectType: CrmListObjectType;
    };

    if (state.name === CRM_LIST_PAGE_ROUTE) {
        return { id: makeCrmListId(crm, objectType), variant: ListVariant.Crm };
    }

    if (state.name === STATIC_LIST_PAGE_ROUTE) {
        return { id, variant: ListVariant.Static };
    }

    trackError(
        new SiError(`Unknown opportunity list route: ${state.name}`, {
            category: errorCategoryMap.invariant,
            component: "crmList",
            operation: "getOpportunityListParams",
        }),
    );

    return undefined;
};
